export async function authFetch(url, options = {}) {
  const token = localStorage.getItem('idToken');
  const headers = {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(options.headers || {}),
  };

  if (options.body && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }

  return fetch(url, {
    ...options,
    credentials: 'include',
    headers,
  });
}
